import React, { useCallback } from 'react';
import { isAfter, isBefore, parseISO } from 'date-fns';
import { Calendar } from 'design-system/calendar/Calendar';
import { Day } from 'design-system/calendar/Day';
import { useDateRange } from 'design-system/calendar/useRange';
export const CalendarRangeFormat = 'yyyy-MM-dd';
export const CalendarRange = React.memo(({ showReset, selectWeek, maxDate, minDate, onChangeRange: onChangeRangeProp, initialDates = [], inRangeMaskStyle, ...props }) => {
    const { checkInRange, onAddDayToRange, checkIsEndDay, checkIsStartDay, resetRange, selectEntireWeek, } = useDateRange(initialDates);
    const onDayPress = useCallback((date) => {
        const newRange = selectWeek
            ? selectEntireWeek(date.dateString)
            : onAddDayToRange(date.dateString);
        onChangeRangeProp?.(newRange);
    }, [onAddDayToRange, onChangeRangeProp, selectEntireWeek, selectWeek]);
    const handleReset = useCallback(() => {
        resetRange();
        onChangeRangeProp?.([]);
    }, [onChangeRangeProp, resetRange]);
    const checkIfDayDisabled = useCallback((date) => {
        if (date && (maxDate || minDate)) {
            if (minDate && maxDate) {
                return (isBefore(parseISO(date), parseISO(minDate)) ||
                    isAfter(parseISO(date), parseISO(maxDate)));
            }
            if (minDate) {
                return isBefore(parseISO(date), parseISO(minDate));
            }
            if (maxDate) {
                return isAfter(parseISO(date), parseISO(maxDate));
            }
        }
        return false;
    }, [maxDate, minDate]);
    return (<Calendar maxDate={maxDate} dayComponent={({ date, state }) => (<Day key={date?.dateString} date={date} isDisabled={checkIfDayDisabled(date?.dateString)} isToday={state === 'today'} isStartDay={checkIsStartDay(date?.dateString)} isEndDay={checkIsEndDay(date?.dateString)} isInRange={checkInRange(date?.dateString)} onDayPress={onDayPress} inRangeMaskStyle={inRangeMaskStyle}/>)} reset={showReset ? handleReset : undefined} {...props}/>);
});
